import React from 'react';

import Disclosure from 'components/Disclosure/Disclosure';
import FormActionResponsiveButtons from 'components/FormActionButtons/FormActionResponsiveButtons';

import { Fields, StepProps } from '../../types';

const StepDisclosure: React.ComponentType<StepProps> = () => (
  <>
    <Disclosure checkboxName={Fields.DisclosureChecked} />
    <FormActionResponsiveButtons hasUnderline />
  </>
);

export default StepDisclosure;
